export default __webpack_public_path__ + "static/sunshine-fading-f7e595c28ed303bf0debf1e4bec6d665.svg";